var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSecureAccount(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "120px",
    viewBox: "0 0 71 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home-stream",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Secure-your-account",
    transform: "translate(-152.000000, -203.000000)",
    fill: "#7BCB45",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(18.000000, 172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(109.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile-alt-solid",
    transform: "translate(25.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.35,0 L10.65,0 C4.7703125,0 0,5.0390625 0,11.25 L0,108.75 C0,114.960938 4.7703125,120 10.65,120 L60.35,120 C66.2296875,120 71,114.960938 71,108.75 L71,11.25 C71,5.0390625 66.2296875,0 60.35,0 Z M35.5,117.5 C31.3515625,117.5 28,114.148438 28,110 C28,105.851562 31.3515625,102.5 35.5,102.5 C39.6484375,102.5 43,105.851562 43,110 C43,114.148438 39.6484375,117.5 35.5,117.5 Z M66,95.7857143 C66,97.5535714 64.5535714,99 62.7857143,99 L9.21428571,99 C7.44642857,99 6,97.5535714 6,95.7857143 L6,12.2142857 C6,10.4464286 7.44642857,9 9.21428571,9 L62.7857143,9 C64.5535714,9 66,10.4464286 66,12.2142857 L66,95.7857143 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSecureAccount);
export default __webpack_public_path__ + "static/media/icSecureAccount.9d38be4d40defc4d9ac2a902fe6c0ad1.svg";
export { ForwardRef as ReactComponent };